<template>
  <div>
    <div class="upload">
      <draggable class="upload-draggable" v-model="images" draggable=".preview-image">
        <template v-if="images.length > 0">
          <div :key="item.key" class="preview-image" v-for="(item, index) in images" :style="{ height: heightReal + 'px', width: widthReal + 'px' }">
            <img class="preview" :src="item.preview | thumbImage(width || 100, height || 100)" :style="{ height: heightReal + 'px', width: widthReal + 'px' }" />
            <div @click="deleteImage(index)" class="iconfont icon-close-o close"></div>
          </div>
        </template>
        <div v-if="images.length < max || !max" class="upload-image" :style="{ height: heightReal + 'px', width: widthReal + 'px' }">
          <div @click="chooseImage" class="upload-btn v-col v-center">
            <i class="icon el-icon-plus"></i>
          </div>
        </div>
      </draggable>
      <input ref="fileImage" hidden class="file" type="file" multiple accept="image/*" />
    </div>
    <upload-dialog v-if="isShowUploadDialog" :show.sync="isShowUploadDialog" type="image" :multiple="multiple" @change="handleChange"></upload-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import uploadDialog from './components/upload-dialog';

export default {
  components: { draggable, uploadDialog },

  props: ['width', 'height', 'max', 'images', 'multiple'],

  model: {
    prop: 'images',
    event: 'change',
  },

  data() {
    return {
      isShowUploadDialog: false,
    };
  },

  computed: {
    widthReal() {
      return this.width > 300 ? 300 : this.width;
    },

    heightReal() {
      return this.width > 300 ? this.height / (this.width / 300) : this.height;
    },
  },

  methods: {
    //选择商品图片
    chooseImage() {
      this.isShowUploadDialog = true;
    },

    //监听图片新增
    handleChange(img) {
      let images = this.images.concat(img);
      this.$emit('change', images);
    },

    //删除图片
    deleteImage(index) {
      let images = JSON.parse(JSON.stringify(this.images));
      images.splice(index, 1);
      this.$emit('change', images);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  display: flex;
  user-select: none;
  flex-wrap: wrap;
}

.upload-draggable {
  display: flex;
  flex-wrap: wrap;
}

.upload-image {
  position: relative;
  width: 100px;
  height: 100px;
}

.upload-btn {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 1px dashed #9a9a9a;
  border-radius: 4px;
  cursor: pointer;
  color: #9a9a9a;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 10px 0 0;

  .icon {
    font-size: 22px;
  }

  .txt {
    font-size: 12px;
  }
}

.preview-image {
  width: 100px;
  height: 100px;
  position: relative;
  margin: 0 10px 10px 0;

  .preview {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 4px;
    cursor: pointer;
    border-radius: 4px;
  }

  .close {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    color: #999;
    cursor: pointer;
  }
}
</style>
